import { API_BASE_URL, HAS_API_URL } from '../config/api';

/**
 * Fetch a URL (e.g. Firebase Storage download URL) and trigger a file save at full resolution.
 * @param {string} url
 * @param {string} baseName Filename without extension
 * @param {{ getIdToken: (forceRefresh?: boolean) => Promise<string> } | null | undefined} user
 */
export async function downloadUrlAsFile(url, baseName, user) {
  if (!HAS_API_URL) {
    throw new Error('Download server is not configured.');
  }
  if (!user) {
    throw new Error('You must be signed in to download.');
  }
  const idToken = await user.getIdToken(true);
  const res = await fetch(`${API_BASE_URL}/api/download-image`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ url, baseName }),
  });
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const filenameFromHeader = (() => {
    const cd = res.headers.get('content-disposition') || '';
    const m = /filename="?([^"]+)"?/i.exec(cd);
    return m?.[1] || `${baseName}.jpg`;
  })();
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filenameFromHeader;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
